import React from 'react'
import SecondLine from '../assets/images/Rectangle 17.png'

function WhiteLine() {
  return (
    <div>
      <img src={SecondLine} alt="" />
    </div>
  )
}

export default WhiteLine